'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {ListItem} from "../ListItem";
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {ButtonState, isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {Button} from '../../buttons/Button';
import {StatefulButton} from '../../buttons/StatefulButton';
import {Modal} from '../../modals/Modal';
import {ModalFooter} from '../../modals/ModalFooter';
import {ModalHeader} from '../../modals/ModalHeader';


export function BaseCreateCardView(props) {
  if (props.isModal) return (
    <Fragment>
      {renderButtonCard(props)}

      {props.showForm && (
        <Modal className="CreateCard_modal">
          <ModalHeader className="CreateCard_modal__header">
            <span>
              {props.modalHeaderLabel}
            </span>
          </ModalHeader>
          <div className="CreateCard CreateCard_form">
            {props.children}
          </div>
          <ModalFooter className="CreateCard_modal__footer">
            {renderButtons(props)}
          </ModalFooter>
        </Modal>)}
    </Fragment>
  );

  return !props.showForm ? renderButtonCard(props) : (
    <div
      className={classNames("CreateCard CreateCard_form", props.className)}
    >
      {props.children}

      {renderButtons(props)}
    </div>
  );
}

function renderButtonCard(props) {
  return (
    <ListItem
      className={classNames("CreateCard", props.className)}
    >
      <Button
        className="CreateCard_placeholder"
        labelClass={props.placeholderLabelClass}
        disabled={props.mode !== ButtonState.START}
        label={props.placeholderLabel}
        onClick={props.onShowForm}
      >
        {props.svgIcon && <SvgIcon
          className="CreateCard_placeholder__svgIcon"
          icon={props.svgIcon}
        />}
      </Button>
    </ListItem>
  );
}

function renderButtons(props) {
  return (
    <div className="CreateCard__buttons">
      <Button
        className="CreateCard__cancelButton"
        disabled={props.mode !== ButtonState.START}
        label={props.cancelLabel}
        onClick={props.onHideForm}
      />
      <StatefulButton
        buttonClassName="CreateCard__saveButton"
        startClassName="CreateCard__saveButton_start"
        frontClassName="CreateCard__saveButton_content"
        backClassName="CreateCard__saveButton_content"
        workingIconClassName="CreateCard__saveButton_icon"
        startLabel={props.createLabel}
        usePropState={true}
        mode={props.mode}
        onClick={props.onTriggerSave}
      />
    </div>
  );
}

BaseCreateCardView.propTypes = {
  className: T.string,
  placeholderLabelClass: T.string,
  showForm: T.bool,
  isModal: T.bool,
  mode: isButtonState,

  onHideForm: T.func,
  onShowForm: T.func,
  onTriggerSave: T.func,

  cancelLabel: T.string,
  createLabel: T.string,
  modalHeaderLabel: T.node,
  placeholderLabel: T.node,
};

BaseCreateCardView.defaultProps = {
  className: '',
};

export const CreateCardView = I18nComponent(BaseCreateCardView, [
  {code: 'default.button.cancel.label', prop: 'cancelLabel'},
  {code: 'default.button.save.label', prop: 'createLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/components/lists/CreateCard/CreateCardView.js